<template>
    <div>
        <label for="localidad">{{ $t('formularios.localidad') }}</label>
        <ValidationProvider name="localidad" id="localidad" rules="required" v-slot="{ errors }">
            <template v-if="locations.length > 0 || forceMultiselect === true">
                <multiselect
                    :disabled="desactivar"
                    v-model="selected"
                    :placeholder="$t('formularios.localidad')"
                    label="nombre"
                    track-by="id"
                    :options="locations"
                    :multiple="false"
                    v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
                />
            </template>
            <template v-else>
                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Localidad" v-model="localidadTexto" @change="handleTextInput" :disabled="desactivar" />
            </template>

            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>

    export default {
        props: {
            provincia: {
                type: Object,
                default: null
            },
            location_id: {
                type: Number,
                default: null
            },
            errors: {
                type: Array,
                default: () => []
            },
            desactivar: {
                type: Boolean,
                default: false
            },
            localidad: {
                type: [String, Object],
                default: null
            },
            forceMultiselect: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                locations: [],
                selected: null,
                localidadTexto: ''
            }
        },
        created() {
            if(this.provincia) {
                if(this.provincia.localidades) {
                    this.locations = this.provincia.localidades;
                    this.syncSelected();
                } else {
                    this.getLocations(this.provincia);
                }
            }
        },
        watch: {
            provincia: function(newVal, oldVal) {
                if(newVal === null) {
                    this.locations = [];
                } else if(newVal !== oldVal) {
                    if(newVal.localidades) {
                        this.locations = newVal.localidades;
                        this.syncSelected();
                    } else {
                        this.getLocations(newVal);
                    }
                }
            }
        },
        methods: {
            handleTextInput() {
                const localidadManual = {
                    id: null,
                    nombre: this.localidadTexto
                };
                this.selected = localidadManual;
                this.$emit('selected', localidadManual);
            },
            getLocations(provincia) {
                if(provincia == null) {
                    this.locations = [];
                    return;
                }
                const data = {
                    filters: {
                        provincia_id: provincia?.id ?? 30,
                    },
                };
                this.$store.dispatch(this.config.getVuexAlias('select.locations'), data).then(res => {
                    this.locations = res.data.data;

                    this.syncSelected();

                    this.$emit('localidadesCargadas', this.locations)
                });
            },
            syncSelectedLocalidad(localidadNombre) {
                if (!localidadNombre || !this.locations.length) {
                    return;
                }
                
                const localidadEncontrada = this.locations.find(location => {
                    if (typeof localidadNombre === 'string') {
                        return location.nombre === localidadNombre;
                    }
                    if (typeof localidadNombre === 'object') {
                        return location.id === localidadNombre.id || location.nombre === localidadNombre.nombre;
                    }                    
                });
                
                if (localidadEncontrada) {
                    this.selected = localidadEncontrada;
                    this.$emit('selected', localidadEncontrada);
                } 
            },
            syncSelectedLocalidadById(locationId) {                
                const localidadEncontrada = this.locations.find(location => location.id === locationId);
                
                if (localidadEncontrada) {
                    this.selected = localidadEncontrada;
                    this.$emit('selected', localidadEncontrada);
                } else {
                    this.selected = null;
                    this.$emit('selected', null);
                }
            },
            syncSelected() {
                if (this.localidad) {
                    if (typeof this.localidad === 'string') {
                        this.localidadTexto = this.localidad;
                    }
                    this.syncSelectedLocalidad(this.localidad);
                }

                if( this.location_id) {
                    this.syncSelectedLocalidadById(this.location_id);
                }
            }
        },
    }
</script>
